import { defineMessages } from 'react-intl';

export default defineMessages({
  queue_waitTime_days: {
    id: 'kustomer.chat.conversation.headerInfo.waitTime.days',
    description: 'Wait time in days',
    defaultMessage: 'Your expected wait time is {waitTime} days',
  },
  queue_waitTime__more_than_days: {
    id: 'kustomer.chat.conversation.headerInfo.waitTime.more_than_days',
    description: 'Wait time is greated than one day',
    defaultMessage: 'Your expected wait time is greater than one day',
  },
  queue_waitTime_hours: {
    id: 'kustomer.chat.conversation.headerInfo.waitTime.hours',
    description: 'Wait time in hours',
    defaultMessage: 'Your expected wait time is {waitTime} hours',
  },
  queue_waitTime_minutes: {
    id: 'kustomer.chat.conversation.headerInfo.waitTime.minutes',
    description: 'Wait time in minutes',
    defaultMessage: 'Your expected wait time is {waitTime} minutes',
  },
  queue_waitTime_seconds: {
    id: 'kustomer.chat.conversation.headerInfo.waitTime.seconds',
    description: 'Wait time in seconds',
    defaultMessage: 'Your expected wait time is {waitTime} seconds',
  },
  queue_waitTime_momentarily: {
    id: 'kustomer.chat.conversation.headerInfo.waitTime.momentarily',
    description: 'Wait time in when waitTime is 0 or null',
    defaultMessage: 'Someone should be with you momentarily',
  },
});
